function copyURI(evt) {
	evt.preventDefault();
	const copyButton = evt.currentTarget;
	const urlToCopy = window.location.href;
	const nameSpan = copyButton.querySelector('.share-button__name');
	const originalText = nameSpan ? nameSpan.textContent.trim() : '';
	
	navigator.clipboard.writeText(urlToCopy).then(() => {
		if (nameSpan) {
			nameSpan.textContent = 'Copied';
			setTimeout(() => {
				nameSpan.textContent = originalText;
			}, 2000);
		}
	});
}

const copyLinks = document.querySelectorAll('.copy-btn');
for (const copyLink of copyLinks) {
	copyLink.addEventListener('click', copyURI);
}

/* Blog: alle Absaetze im Artikeltext einheitlich einruecken (auch mit fett, kursiv oder Link) */
for (const p of document.querySelectorAll('.article-template__content > p')) {
	p.classList.add('only');
}
